export default function numSort(num: number | string): string {
  const validNumber: string = String(num)?.includes('e') ? String(BigInt(Number(num || 0))) : String(num)

  const splitChar: '.' | ',' = validNumber?.includes(',') ? ',' : '.'
  const numStr: string = validNumber?.split(splitChar)[0]
  const numArr: string[] = []

  for (let i: number = numStr?.length - 1, j: number = 0; i >= 0; i--, j++) {
    if (j !== 0 && j % 3 === 0) {
      numArr?.push(' ')
    }
    numArr?.push(numStr[i])
  }

  return `${numArr?.reverse()?.join('')}${validNumber?.split(splitChar)[1] ? `,${validNumber?.split(splitChar)[1]}` : ''}`
}